// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderClients_wrapper__Zt-TK","left":"HeaderClients_left__cVQFE","value":"HeaderClients_value__GrrFE","add":"HeaderClients_add__ZLRRB"};